import type { ReactNode } from 'react';
import {
  Briefcase,
  Crown,
  Handshake,
  Headset,
  HeartPulse,
  Laptop2,
  Plane,
  Globe2,
  Code,
  Stethoscope,
  User,
  Users,
} from 'lucide-react';

export function focusToTitle(focus: string): string {
  return (focus || '')
    .replace(/[_-]+/g, ' ')
    .trim()
    .split(' ')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

export function getFocusIcon(focus: string, className = 'size-3.5'): ReactNode {
  const PatientIcon = () => (
    <span className="relative inline-flex">
      <User className={className} />
      <HeartPulse className="absolute right-0 bottom-0 size-2 text-red-500" />
    </span>
  );

  switch (focus) {
    case 'candidate':
      return <User className={className} />;
    case 'employer':
      return <Briefcase className={className} />;
    case 'recruiter':
      return <Users className={className} />;
    case 'platform':
      return <Globe2 className={className} />;
    case 'developer':
      return <Code className={className} />;
    case 'traveler':
      return <Plane className={className} />;
    case 'agent':
      return <Headset className={className} />;
    case 'patient':
      return <PatientIcon />;
    case 'practitioner':
      return <Stethoscope className={className} />;
    case 'client':
      return <Handshake className={className} />;
    case 'engineer':
      return <Laptop2 className={className} />;
    case 'principal':
      return <Crown className={className} />;
    case 'operator':
      return <Headset className={className} />;
    default:
      return <User className={className} />;
  }
}
